import history from '../history';
import { buildLoginPathWithRedirect, readRedirectFromSearch, sanitizeRedirectPath } from './safeRedirect';
import { getNotificationRoute } from './notificationRoute';

const storeKeyToken = 'x-access-token';
const storeKeyTokenExpires = 'x-access-token-expires';

let pendingPushRoute: string | null = null;

export const setPendingPushRoute = (route: string): void => {
  pendingPushRoute = route;
};

export const consumePendingPushRoute = (): string | null => {
  const route = pendingPushRoute;
  pendingPushRoute = null;
  return route;
};

export const resolvePushRoute = (data?: Record<string, any> | null): string | null => {
  if (!data) return null;

  const explicitRoute = sanitizeRedirectPath(data.route);
  if (explicitRoute) return explicitRoute;

  const type = typeof data.type === 'string' ? data.type.trim() : '';
  if (!type) return null;

  return getNotificationRoute({
    type,
    related: data.related,
    relatedCode: data.relatedCode,
  });
};

const hasValidSession = (): boolean => {
  try {
    if (!window?.localStorage?.getItem(storeKeyToken)) return false;
    const expires = Number(window.localStorage.getItem(storeKeyTokenExpires) || 0);
    return !expires || Date.now() < expires;
  } catch (e) {
    return false;
  }
};

const currentAppPath = (): string | null =>
  sanitizeRedirectPath(`${window?.location?.pathname || ''}${window?.location?.search || ''}`);

export const resolvePostLoginPath = (): string => {
  const fromQuery = readRedirectFromSearch(window?.location?.search);
  const pending = consumePendingPushRoute();
  return fromQuery || pending || currentAppPath() || '/';
};

export const navigateToRoute = (route?: string | null): void => {
  if (!route) return;

  if (hasValidSession()) {
    history.push(route);
    return;
  }

  setPendingPushRoute(route);
  history.replace(buildLoginPathWithRedirect(route));
};

export const navigateFromPush = (data?: Record<string, any> | null): void => {
  navigateToRoute(resolvePushRoute(data));
};
